import { LinkTab, TabContent, Tabs } from 'ms-components/Tabs';
import {
  validateCoreTextbookSubtopicActiveTab,
  type CoreTextbookSubtopicActiveTab,
} from 'ms-pages/Textbooks/components/SubtopicDetailView/helpers';
import useQueryParam from 'ms-utils/hooks/useQueryParam';

export function FreeCoreTextbookSubtopicDetailViewTabs() {
  const [activeTab, , getTabLink] =
    useQueryParam<CoreTextbookSubtopicActiveTab>(
      'coreTextbookSubtopicActiveTab',
      'solidifyLesson',
      validateCoreTextbookSubtopicActiveTab,
    );

  return (
    <Tabs>
      <LinkTab
        active={activeTab === 'solidifyLesson'}
        to={getTabLink('solidifyLesson')}
      >
        <TabContent>Lesson</TabContent>
      </LinkTab>
      <LinkTab
        active={activeTab === 'interactive' || activeTab === 'worksheet'}
        to={getTabLink('interactive')}
      >
        <TabContent>Practice</TabContent>
      </LinkTab>
    </Tabs>
  );
}
